// copy content
const copyContent = () => {
  let container = document.querySelector('.js-copy__message');

  if(!container) return;

  let selectors = {
    copyElement: container.querySelector('strong'),
    tooltip: container.getAttribute('data-tooltip')
  }

  if(!selectors.copyElement) return;

  function createTooltip() {
    let tooltipElement = document.createElement('span');
    tooltipElement.classList.add('tooltip');
    tooltipElement.innerText = 'Click to copy';

    selectors.copyElement.appendChild(tooltipElement);
  }

  function changeTooltipText() {
    let tooltipElement = container.querySelector('.tooltip');
    tooltipElement.innerText = 'Copied to clipboard';
  }

  if(selectors.tooltip === 'true') createTooltip();

  selectors.copyElement.addEventListener('click', () => {
    const text = selectors.copyElement.firstChild.textContent;

    try {
      if(selectors.tooltip === 'true') changeTooltipText();
      navigator.clipboard.writeText(text);
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  });
};

copyContent();

// countdown timer
class CountdownTimer extends HTMLElement {
  constructor() {
    super();

    this.daysElement = this.querySelector('.timepart--day');
    this.hoursElement = this.querySelector('.timepart--hour');
    this.minutesElement = this.querySelector('.timepart--minute');
    this.secondsElement = this.querySelector('.timepart--second');

    this.timeStart = this.getAttribute('time-start');
    this.timeEnd = this.getAttribute('time-limit');

    this.countdownInterval = setInterval(this.countdown.bind(this), 1000);
    this.setTimerWidth();
  }

  countdown() {
    const currentTime = new Date();
    const startTime = new Date(this.timeStart);
    const endTime = new Date(this.timeEnd);

    // Check if the current time is before the start time
    if (currentTime < startTime) return;

    const totalSeconds = (endTime - currentTime) / 1000;
    const minutes = Math.floor(totalSeconds / 60) % 60;
    const hours = Math.floor(totalSeconds / 3600) % 24;
    const days = Math.floor(totalSeconds / 3600 / 24);
    const seconds = Math.floor(totalSeconds) % 60;

    (totalSeconds <= 0) ? this.setAttribute('aria-hidden', true) : this.setAttribute('aria-hidden', false);

    this.counterHasDays = (days <= 0);

    this.updateTimer(this.daysElement, days, this.counterHasDays);
    this.updateTimer(this.hoursElement, hours, this.counterHasDays);
    this.updateDefaultDigit(this.minutesElement, minutes);
    this.updateDefaultDigit(this.secondsElement, seconds);

    // Check if the countdown has reached zero
    if (totalSeconds <= 0) {
      this.disconnectedCallback();
    }
  }

  setTimerWidth() {
    this.style.setProperty('--timer-width', `${this.offsetWidth}px`);
  }

  updateTimer(digitElement, digit, dayDigit) {
    if(digit <= 0 && dayDigit) {
      digitElement.style.display = 'none';
      digitElement.nextElementSibling.style.display = 'none';
      this.setTimerWidth();
    } else {
      this.updateDigit(digitElement, digit);
    }
  }

  updateDefaultDigit(digitElement, digit) {
    const upperDigit = digitElement.querySelector('[data-upper-digit]');
    const lowerDigit = digitElement.querySelector('[data-lower-digit]');

    if(digit <= 0) {
      upperDigit.textContent = 0;
      lowerDigit.textContent = 0;
      upperDigit.setAttribute('data-flip', 'false');
      lowerDigit.setAttribute('data-flip', 'false');
    } else {
      this.updateDigit(digitElement, digit);
    };
  }

  updateDigit(digitElement, digit) {
    const upperDigit = digitElement.querySelector('[data-upper-digit]');
    const lowerDigit = digitElement.querySelector('[data-lower-digit]');

    let digitPart = {
      upper: Math.floor(digit / 10),
      lower: digit % 10
    };

    if (digitPart.upper !== parseInt(upperDigit.textContent)) {
      upperDigit.textContent = digitPart.upper;
      this.singleDigitAnimation(upperDigit, 'data-flip');
    }

    if (digitPart.lower !== parseInt(lowerDigit.textContent)) {
      lowerDigit.textContent = digitPart.lower;
      this.singleDigitAnimation(lowerDigit, 'data-flip');
    }
  }

  singleDigitAnimation(digitElement, attribute) {
    digitElement.setAttribute(attribute, 'true');
    setTimeout(() => digitElement.setAttribute(attribute, 'false'), 500);
  }

  disconnectedCallback() {
    clearInterval(this.countdownInterval);
  }
}

customElements.define('countdown-timer', CountdownTimer);

